import Store from 'store/store'
import { Component } from 'utils/jsx'
import classnames from 'classnames'

import Button from 'components/dom/Button'

export default class Modal extends Component {
  beforeRender (props) {
    this.destroy = this.destroy.bind(this)
    this.captureEscapeKey = this.captureEscapeKey.bind(this)

    this.state = {
      lastActiveElement: document.activeElement
    }
  }

  template (props) {
    return (
      <section class='modal-wrapper' event-click={this.destroy}>
        <div
          class={classnames('modal', props.class)}
          data-tone={props.tone || 'neutral'}
          event-click={e => e.stopPropagation()}
        >
          <header class='modal__header'>
            <div class='modal__title'>{props.title}</div>
            <Button title='Fermer cette alerte' icon='close' event-click={this.destroy} />
          </header>
          <div class='modal__content'>
            {props.children}
          </div>
        </div>
      </section>
    )
  }

  afterRender () {
    Store.app.hasOpenModal.set(true)
    window.addEventListener('keyup', this.captureEscapeKey)
  }

  afterMount () {
    this.state.lastActiveElement && this.state.lastActiveElement.blur()
  }

  captureEscapeKey (e) {
    if (e.key !== 'Escape') return
    this.destroy()
  }

  beforeDestroy () {
    Store.app.hasOpenModal.set(false)
    window.removeEventListener('keyup', this.captureEscapeKey)

    if (this.state.lastActiveElement) {
      // Store element inside the closure so that there is no reference error
      // when calling the timeout after having destroyed the component
      const el = this.state.lastActiveElement
      window.setTimeout(() => el.focus(), 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Modal.js